import { OrderDetailsFragment } from "@dashboard/graphql";

// The storefront/checkout stores the customer's tax identification number (in
// Portugal the NIF / "número de contribuinte", i.e. the VAT number) as an order
// metadata entry under this key, and the backend email templates render it from
// `order.metadata.nif`. The dashboard mirrors the same key so VAT info entered
// while editing the billing address ends up in the exact same place.
export const ORDER_NIF_KEY = "nif";

export const getOrderNif = (
  order: Pick<OrderDetailsFragment, "metadata"> | undefined | null,
): string => (order?.metadata ?? []).find(entry => entry?.key === ORDER_NIF_KEY)?.value ?? "";
